import { deepFind } from 'new-ui/functions';

export const checkIfStateValueIsTrue = (state, condition) => {
  const { ifId } = condition;

  return deepFind(state, ifId);
};
